import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/themeFour/CalenderGreen.png'


const _hoisted_1 = { class: "dayImage" }
const _hoisted_2 = {
  key: 0,
  class: "dateText"
}
const _hoisted_3 = {
  key: 1,
  class: "dayText"
}
const _hoisted_4 = { class: "toptext" }
const _hoisted_5 = {
  class: "toptext",
  style: {"color":"#ffff"}
}
const _hoisted_6 = { class: "toptext" }
const _hoisted_7 = {
  class: "toptext",
  style: {"color":"#ffff"}
}
const _hoisted_8 = { style: {"color":"#27D48B"} }
const _hoisted_9 = { style: {"color":"#ffcb52"} }
const _hoisted_10 = {
  key: 0,
  class: "claimBtn"
}
const _hoisted_11 = {
  key: 1,
  class: "right-texts"
}
const _hoisted_12 = {
  key: 0,
  style: {"color":"#ff0000"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"#0484ff"}
}
const _hoisted_14 = {
  key: 2,
  style: {"color":"#36d836"}
}
const _hoisted_15 = {
  key: 3,
  style: {"color":"#ff0000"}
}
const _hoisted_16 = {
  key: 4,
  style: {"color":"#ff0000"}
}

import { } from 'vue';
import { checkDate, formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';


export default /*@__PURE__*/_defineComponent({
  __name: 'dayList',
  props: {
    day: {
        type: Number
    },
    valueOne: {
        type: Number
    },
    valueTwo: {
        type: Number
    },
    currenyLable: {
        type: Boolean
    },
    labelOne: {
        type: String
    },
    labelTwo: {
        type: String
    },
    time: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
    isShowHistory: {
        type: Boolean,
        default: false
    }
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const clickOnButton = () => {
    emits('getClaim')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_P = _resolveComponent("P")!

  return (_openBlock(), _createBlock(_component_van_row, {
    class: _normalizeClass(["cardContainer", { historyMode: __props.isShowHistory }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_col, {
        span: "5",
        class: "dayColumn"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            (props.time)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(formatUnixTimestamp)(props.time)?.split(' ')[0]), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.day), 1))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "13",
        style: {"padding":"0 10px","display":"flex","align-items":"center","border-right":"3px dashed #80808070"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_row, null, {
                default: _withCtx(() => [
                  (__props.isShowHistory ? true : _unref(checkDate)(_unref(formatUnixTimestamp)(props.time)) == 0)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: "24"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_row, { class: "topData" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_col, {
                                span: "12",
                                class: "topCol",
                                style: {"border-right":"3px solid #80808070"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('activity.available')), 1),
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatCurrency)(__props.availableAmount)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_van_col, {
                                span: "12",
                                class: "topCol"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('activity.givenAmount')), 1),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatCurrency)(__props.givenAmount)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_col, {
                    span: "24",
                    style: {"padding-left":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(['middle-texts', props.activityStatus == 0 || props.activityStatus == 11 || props.activityStatus == 2 ? 'middle-pending' : ''])
                      }, [
                        _createVNode(_component_P, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(props.labelOne!)) + ": ", 1),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(props.currenyLable ? 'R$' :
                                    '') + " " + _toDisplayString(props.valueOne) + _toDisplayString(props.currenyLable ? '' : '%'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_P, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(props.labelTwo!)) + ": ", 1),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(props.valueTwo) + "X", 1)
                          ]),
                          _: 1
                        })
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "6",
        style: {"padding-left":"10px","display":"flex","align-items":"center","justify-content":"center"}
      }, {
        default: _withCtx(() => [
          (__props.isShowHistory ? false : __props.activityStatus == 0 && _unref(checkDate)(_unref(formatUnixTimestamp)(props.time)) == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "click_btn",
                  onClick: clickOnButton
                }, _toDisplayString(_ctx.$t('activity.click')), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                (props.activityStatus == 0 && __props.returnTurnover)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                  : (props.activityStatus == 0 || props.activityStatus == 11)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                    : (props.activityStatus == 1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                      : (props.activityStatus == 2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                        : (props.activityStatus == 3)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                          : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})